import { render } from "./ChildRecordsContainer.vue?vue&type=template&id=26bfcdba&scoped=true&ts=true"
import script from "./ChildRecordsContainer.vue?vue&type=script&lang=ts"
export * from "./ChildRecordsContainer.vue?vue&type=script&lang=ts"

import "./ChildRecordsContainer.vue?vue&type=style&index=0&id=26bfcdba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bfcdba"]])

export default __exports__